<div class="container is-relative is-flex">
  <ng-content></ng-content>
</div>